module.exports = __webpack_public_path__ + "static/media/close.1cc1e90b.svg";